// extracted by mini-css-extract-plugin
export default {"wrapper":"n2","in_view":"o2","in_view_scrolled":"p2","img":"q2","content":"r2","icons":"s2","icon":"t2","text_wrapper":"u2"};
    if(module.hot) {
      // 1713211527802
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  